import { EventBusy } from '@mui/icons-material';
import { Box, SxProps, Theme } from '@mui/material';
import { IconTooltip } from 'common/ui';
import { ReviewIcon } from 'common/icons/ReviewIcon';
import { CampaignListItem } from '../types/CampaignListItem';

type Props = {
  campaign: CampaignListItem;
};

const moreTimeIconSx: SxProps<Theme> = {
  fontSize: '20px',
  color: (theme) => theme.palette.warning.dark
};

export const CampaignReviewIcon: React.FC<Props> = ({ campaign }) => {
  const isParent = campaign.campaignGroupId && campaign.isParent;
  const needsReview = campaign.needsReview;
  const isNestedCampaignNeedsReview = campaign.isNestedCampaignNeedsReview;
  const hasMoreTimeRequested = campaign.hasMoreTimeRequested;

  // Meeting/more-time takes priority over the generic review state.
  if (hasMoreTimeRequested) {
    return (
      <IconTooltip title="A candidate has requested more time">
        <Box sx={{ display: 'inline-flex' }}>
          <EventBusy sx={moreTimeIconSx} />
        </Box>
      </IconTooltip>
    );
  }

  if (needsReview) {
    return (
      <IconTooltip title="Popp needs your help">
        <Box>
          <ReviewIcon />
        </Box>
      </IconTooltip>
    );
  }

  if (isParent && isNestedCampaignNeedsReview) {
    return (
      <IconTooltip title="Popp needs your help">
        <Box>
          <ReviewIcon color="customGrey.medium" />
        </Box>
      </IconTooltip>
    );
  }

  return null;
};
